import { Box, Typography } from '@mui/material';
import { Home, Map, Place, Public } from '@mui/icons-material';
import React from 'react';
import InfoRow from './InfoRow';

interface LocationSectionProps {
  region: string | null;
  province: string | null;
  commune: string | null;
  address: string | null;
}

const LocationSection: React.FC<LocationSectionProps> = ({
  region,
  province,
  commune,
  address,
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box
        sx={{
          backgroundColor: 'rgba(255, 152, 0, 0.08)',
          borderRadius: '8px',
          px: 1.5,
          py: 0.8,
          border: '1px solid rgba(255, 152, 0, 0.15)',
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{
            fontWeight: 600,
            color: 'warning.main',
            fontSize: '0.75rem',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            textAlign: 'center',
          }}
        >
          Ubicación
        </Typography>
      </Box>
      <InfoRow
        label="Región"
        value={region}
        icon={<Public sx={{ fontSize: '0.8rem', color: 'warning.main' }} />}
      />
      <InfoRow
        label="Provincia"
        value={province}
        icon={<Map sx={{ fontSize: '0.8rem', color: 'warning.main' }} />}
      />
      <InfoRow
        label="Comuna"
        value={commune}
        icon={<Place sx={{ fontSize: '0.8rem', color: 'warning.main' }} />}
      />
      <InfoRow
        label="Dirección"
        value={address}
        maxLength={45}
        icon={<Home sx={{ fontSize: '0.8rem', color: 'warning.main' }} />}
      />
    </Box>
  );
};

export default LocationSection;
